<template>
    <Row class="check" type="none" v-if="saleProductDto">

        <RowColumn>
            <Row type="none">
                <div class="ml-1">
                    <TextTag class="d-flex justify-content-center" style="font-size: 28px" :is-block=true
                             :is-bold="true">
                        "{{ getUserCompany.name }}"
                    </TextTag>
                    <TextTag :is-block=true :is-bold="true">
                        {{ $t('printView.receipt') }} {{ saleProductDto.key }}
                    </TextTag>
                    <TextTag v-if="getUser.person.telephone" :is-block=true :is-bold="true">
                        {{ $t('company.title') }} {{ $t('company.telephone') }}: {{ getUser.person.telephone }}
                    </TextTag>
                    <TextTag :is-block=true :is-bold="true">
                        {{ $t('date') }}: {{ dateTimeFormat(saleProductDto.number) }}
                    </TextTag>
                    <TextTag v-if="getUser.person" :is-block=true :is-bold="true">
                        {{ $t('sale.seller') }}: {{ getUser.person.givenName }} {{ getUser.person.familyName }}
                    </TextTag>
                    <hr class="m-0 p-0" style="border: 1px solid black">

                </div>
            </Row>
        </RowColumn>

        <GoBackButton class="mt-3 mr-2 go-back-btn"/>

        <div>
            <table
                class="table"
                style="border-bottom: 2px dotted black !important;"
            >
                <tbody>
                <tr v-for="(item, index) in saleProductDto.saleProductDtos.concat(saleProductDto.saleServiceDtos)"
                    v-bind:key="index">
                    <td style="border-bottom: 2px dotted black !important">
                        <div style="font-weight: bold" v-if="item['@type'] === 'ProductInWarehouse'">
                            {{ getProductName(item) }}
                        </div>
                        <div v-else>
                            <span style="font-weight: bold">{{ item.service.name + ' ' }}</span>
                            <span style="font-size: 12px">{{ '(' + $t('service.title') + ')' }}</span>
                        </div>
                        <div class="d-flex justify-content-between" style="font-size: 11px">
                            <div>{{ getProductAmountAndUnitOfMeasure(item) }} * {{ showPrice(item) }}</div>
                            <div>{{ showTotalRowPrice(item) }}</div>
                        </div>
                        <span v-if="item['@type'] === 'ProductInWarehouse'">
                            <div v-if="item.product.tax !== null"
                                 class="d-flex justify-content-between" style="font-size: 14px">
                                <div>{{ getTax(item) }}</div>
                                <div>{{ getTaxAmount(item) }}</div>
                            </div>
                        </span>
                    </td>
                </tr>
                <tr>
                    <td v-if="saleProductDto.saleServiceDtos.length > 0"
                        class="d-flex justify-content-between">
                        <div>{{ $t('service.servicePrice') }}</div>
                        <div>
                            {{
                                showCurrencyById(
                                    getCurrencyByShortName(saleProductDto.currentCurrency).id, getServicesTotalPrice(saleProductDto.saleServiceDtos))
                            }}
                        </div>
                    </td>
                </tr>
                <tr>
                    <td
                        class="d-flex justify-content-between"
                    >
                        <div>
                            <h5>{{ $t('sale.totalSum') }}</h5>
                        </div>
                        <div>
                            <h5>
                                {{
                                    getPrice()
                                }}
                            </h5>
                        </div>
                    </td>
                </tr>

                <tr v-if="saleProductDto.bonusSumAmount > 0">
                    <td
                        class="d-flex justify-content-around"
                    >
                        <div>
                            <h5>{{ $t('sale.discount.title') }}</h5>
                        </div>
                        <div>
                            <h5>{{ showCurrencyById(getCurrencyByShortName(saleProductDto.currentCurrency).id, saleProductDto.bonusSumAmount) }}</h5>
                        </div>
                    </td>
                </tr>
                <tr v-if="saleProductDto.discountPercent > 0">
                    <td
                        class="d-flex justify-content-between">
                        <div>
                            <h5>{{ $t('sale.discount.title') }}</h5>
                        </div>
                        <div>
                            <h5>{{
                                    saleProductDto.discountPercent + '% = ' + showCurrencyById(getCurrencyByShortName(saleProductDto.currentCurrency).id, parseFloat(saleProductDto.bonusPercentAmount))
                                }}</h5>
                        </div>
                    </td>
                </tr>

                <tr>

                    <td v-if="Number(saleProductDto.taxAmount) > 0"
                        class="d-flex justify-content-between"
                        style="font-weight: bold">
                        <div>
                            <h5>{{ saleProductDto.isTaxInPrice ? $t('sale.tax.inPriceOnCheck') : '' }}{{
                                    $t('sale.tax.title')
                                }}</h5>
                        </div>
                        <div>
                            <h5>{{ showCurrencyById(getCurrencyByShortName(saleProductDto.currentCurrency).id, saleProductDto.taxAmount) }}</h5>
                        </div>
                    </td>
                    <td v-else-if="taxAmount > 0"
                        class="d-flex justify-content-between"
                        style="font-weight: bold">
                        <div>
                            <h5>{{ saleProductDto.isTaxInPrice ? $t('sale.tax.inPriceOnCheck') : '' }}{{
                                    $t('sale.tax.title')
                                }}</h5>
                        </div>
                        <div>
                            <h5>{{ showCurrencyById(getCurrencyByShortName(saleProductDto.currentCurrency).id, taxAmount) }}</h5>
                        </div>
                    </td>
                </tr>

                <tr>
                    <td
                        class="d-flex justify-content-between"
                    >
                        <div>
                            <h5>{{ $t('sale.finalSum') }}</h5>
                        </div>
                        <div>
                            <h5>
                                {{
                                    showCurrencyById(getCurrencyByShortName(saleProductDto.currentCurrency).id, parseFloat(saleProductDto.totalPurchaseAmount))
                                }}
                            </h5>
                        </div>
                    </td>
                </tr>

                <tr v-if="parseFloat(saleProductDto.cashback)">
                    <td
                        class="d-flex justify-content-between">
                        <div>
                            <h5>{{ $t('customer.cashback.payFromCashback') }}</h5>
                        </div>
                        <div>
                            <h5>
                                {{
                                    showCurrencyById(getCurrencyByShortName(saleProductDto.currentCurrency).id, saleProductDto.cashback)
                                }}
                            </h5>
                        </div>
                    </td>
                </tr>

                <tr>
                    <td
                        class="d-flex justify-content-between">
                        <div>
                            <h5>{{ $t('payed') }}</h5>
                        </div>
                        <div>
                            <h5>
                                {{
                                    showCurrencyById(getCurrencyByShortName(saleProductDto.currentCurrency).id, (parseFloat(saleProductDto.payedAmount) + parseFloat(saleProductDto.oddMoney)) - parseFloat(saleProductDto.cashback))
                                }}
                            </h5>
                        </div>
                    </td>
                </tr>

                <tr v-if="Math.round(saleProductDto.totalPurchaseAmount - saleProductDto.payedAmount) > 0">
                    <td
                        class="d-flex justify-content-around">
                        <div>
                            <h5>{{ $t('debt') }}</h5>
                        </div>
                        <div>
                            <h5>
                                {{
                                    showCurrencyById(getCurrencyByShortName(saleProductDto.currentCurrency).id, saleProductDto.totalPurchaseAmount - saleProductDto.payedAmount - saleProductDto.bonusSumAmount)
                                }}
                            </h5>
                        </div>
                    </td>
                </tr>
                <tr v-if="parseFloat(saleProductDto.oddMoney) > 0.0">
                    <td class="d-flex justify-content-around">
                        <div>
                            <h5>{{ $t('sale.oddMoney') }}</h5>
                        </div>
                        <div>
                            <h5>{{ showCurrencyById(getCurrencyByShortName(saleProductDto.currentCurrency).id, saleProductDto.oddMoney) }}</h5>
                        </div>
                    </td>
                </tr>

                </tbody>
            </table>

        </div>

        <RowColumn>
            <Row type="none" v-if="customer">
                <div class="mr-1 font-size">
                    <TextTag :is-block=true :is-bold="true">
                        {{ $t('customer.title') }}: {{ getCustomerName(customer) }}
                    </TextTag>
                    <hr class="m-0 p-0">
                    <TextTag v-if="getCustomerPhoneNumber(customer)" :is-block=true :is-bold="true">
                        {{ getCustomerPhoneNumber(customer) }}
                    </TextTag>
                    <hr class="m-0 p-0" style="border: 1px solid black">
                    <TextTag :is-block=true :is-bold="true">
                        {{ $t('hasPayed') }}: {{ saleProductDto.isPayed ? $t('yes') : $t('no') }}
                    </TextTag>
                    <hr class="m-0 p-0" style="border: 0.5px solid black">
                    <TextTag :is-block=true v-if="getUserCompany.tin">
                        {{ $t('companyRequisites.tin') }}:
                        <span style="font-weight: bold">{{ getUserCompanyy.tin }}</span>
                    </TextTag>
                    <TextTag :is-block=true v-if="getUserCompany.gceo">
                        {{ $t('companyRequisites.gceo') }}:
                        <span style="font-weight: bold">{{ getUserCompany.gceo }}</span>
                    </TextTag>
                    <hr v-if="getUserCompany.tin || getUserCompany.gceo" class="m-0 p-0"
                        style="border: 0.5px solid black">
                    <TextTag :is-block=true v-if="getUserCompany.legalAddress">
                        {{ $t('companyRequisites.legalAddress') }}:
                        <span style="font-weight: bold">{{ getUserCompany.legalAddress }}</span>
                    </TextTag>
                    <TextTag :is-block=true v-if="getUserCompany.physicalAddress">
                        {{ $t('companyRequisites.physicalAddress') }}:
                        <span style="font-weight: bold">{{ getUserCompany.physicalAddress }}</span>
                    </TextTag>
                    <hr v-if="getUserCompany.legalAddress || getUserCompany.physicalAddress" class="m-0 p-0"
                        style="border: 0.5px solid black">
                    <TextTag :is-block=true v-if="getUserCompany.chiefDirector">
                        {{ $t('companyRequisites.chiefDirector') }}:
                        <span style="font-weight: bold">{{ getUserCompany.chiefDirector }}</span>
                    </TextTag>
                    <hr v-if="getUserCompany.chiefDirector"
                        class="m-0 p-0" style="border: 0.5px solid black">
                    <TextTag :is-block=true>
                        <div class="font-weight-bold" style="font-size: 10px">
                            {{ getInfo }}
                        </div>
                    </TextTag>
                    <hr v-if="getInfo" class="m-0 p-0" style="border: 0.5px solid black">
                    <TextTag class="d-flex justify-content-center"
                             style="font-size: 20px; font-weight: normal !important;" :is-block=true
                             :is-bold="true">
                        {{ $t('sale.thankPurchase') }}!!!
                    </TextTag>
                </div>
            </Row>
        </RowColumn>

        <GoBackButton class="my-3 mr-2 go-back-btn" v-if="saleProductDto.saleProductDtos.length >= 37"/>

    </Row>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import currencyFormatMixin from "@/mixin/currencyFormatMixin";
import dateFormattingMixin from "@/mixin/dateFormattingMixin";
import Row from "@/components/html/Row";
import TextTag from "@/components/html/TextTag";
import GoBackButton from "@/components/GoBackButton";
import RowColumn from "@/components/RowColumn";
import PrintStyleMixin from "@/mixin/PrintStyleMixin";
import CurrencyRateMixin from "@/mixin/currencyRateMixin";
import Localbase from "localbase";

export default {
    name: "ShowPrintCheckVersion",
    mixins: [currencyFormatMixin, dateFormattingMixin, PrintStyleMixin, CurrencyRateMixin],
    components: {
        GoBackButton,
        TextTag,
        Row,
        RowColumn
    },
    computed: {
        ...mapGetters(['getSale', 'isAuthenticated', 'getUser', 'getCustomer', 'getUserCompany', 'getUserPerson', 'getInfo', 'getCurrencyByShortName']),
    },
    data() {
        return {
            taxAmount: 0,
            saleProductDto: null,
            customer: null,
            baseName: process.env.VUE_APP_BASE_NAME,
        }
    },
    methods: {
        ...mapActions(['fetchSale', 'fetchUser', 'fetchRefreshToken', 'fetchCustomer']),
        checkTaxInPrice() {
            this.saleProductDto.saleProductDtos.map(item => {
                if (item.product.tax !== null) {
                    if (this.saleProductDto.isTaxInPrice) {
                        this.taxAmount += this.getTaxInPriceAmount(item.sum, item.product.tax.percent)
                    } else {
                        this.taxAmount += item.sum * item.product.tax.percent / 100
                    }
                }
            })
        },
        getPrice() {
            let tax = this.saleProductDto.taxAmount > 0 ? this.saleProductDto.taxAmount : 0

            if (tax > 0) {
                return this.showCurrencyById(
                    this.getCurrencyByShortName(this.saleProductDto.currentCurrency).id,
                    this.saleProductDto.totalPurchaseAmount > 0 ?
                        parseFloat(this.saleProductDto.totalPurchaseAmount) + parseFloat(this.saleProductDto.bonusSumAmount) + parseFloat(this.saleProductDto.bonusPercentAmount) - tax :
                        (this.saleProductDto.totalPurchaseAmount - this.saleProductDto.taxAmount) - tax)
            }

            return this.showCurrencyById(
                this.getCurrencyByShortName(this.saleProductDto.currentCurrency).id,
                this.saleProductDto.totalPurchaseAmount > 0 ?
                    parseFloat(this.saleProductDto.totalPurchaseAmount) + parseFloat(this.saleProductDto.bonusSumAmount) + parseFloat(this.saleProductDto.bonusPercentAmount) :
                    (this.saleProductDto.totalPurchaseAmount - this.saleProductDto.taxAmount) + parseFloat(this.saleProductDto.bonusSumAmount) + parseFloat(this.saleProductDto.bonusPercentAmount))


        },
        calculateReversePercentAmount(amount, percent) {
            if (percent === null) {
                percent = 0
            }

            return amount * 100 / (100 - percent)
        },
        numberWithCommas(x) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        },
        getServicesTotalPrice(saleServices) {
            let totalPrice = 0.0
            for (let saleService of saleServices) {
                totalPrice += parseFloat(saleService.price)
            }

            return totalPrice
        },
        getTaxAmount(saleProductOrService) {
            let tax = saleProductOrService.product.tax ?? this.getUserCompany.tax

            return this.showCurrencyById(
                this.getSale.currency.id,
                this.getSale.isTaxInPrice ?
                    this.getTaxInPriceAmount(saleProductOrService.price, tax.percent) :
                    saleProductOrService.price * parseFloat(tax.percent) / 100
            )
        },
        getTaxInPriceAmount(amount, percent) {
            return amount * parseFloat(percent) / 100
        },
        getTax(saleProductOrService) {
            let tax = saleProductOrService.product.tax ?? this.getUserCompany.tax
            let taxInPrice = this.getSale.isTaxInPrice ? this.$t('sale.tax.inPriceOnCheck') : ''

            return taxInPrice + tax.name + ' ' + parseFloat(tax.percent) + ' %'
        },
        getProductName(saleProductOrService) {
            if (saleProductOrService['@type'] === "ProductInWarehouse") {
                return saleProductOrService.product.name
            }

            return saleProductOrService.name + ' ' + '(' + this.$t('service.title') + ')'
        },
        getProductAmountAndUnitOfMeasure(saleProductOrService) {
            if (saleProductOrService['@type'] === "ProductInWarehouse") {
                if (saleProductOrService.amountWithMeasure) {
                    return saleProductOrService.amountWithMeasure
                }

                this.checkForAdditionalUnitOfMeasure(saleProductOrService)
            }

            return parseFloat(saleProductOrService.quantity)

        },
        checkForAdditionalUnitOfMeasure(saleProduct) {
            let amount = saleProduct.quantity
            let response = ''

            if (saleProduct.product.additionalUnitOfMeasures.length > 0) {
                let measures = saleProduct.product.additionalUnitOfMeasures.sort((a, b) => b.howMany - a.howMany)

                measures.map((measure, index) => {
                    if (index > 0) {
                        response += ', '
                    }

                    response += Math.floor(amount / measure.howMany) + ' ' + measure.unitOfMeasure

                    amount %= measure.howMany
                })

                if (amount > 0) {
                    response += ', ' + amount + ' ' + this.showUnitOfMeasurement(saleProduct)
                }

                return saleProduct.amountWithMeasure = parseFloat(response)
            }

            return saleProduct.amountWithMeasure =
                parseFloat(saleProduct.quantity) + ' ' + this.showUnitOfMeasurement(saleProduct)
        },
        showUnitOfMeasurement(saleProduct) {
            return this.showUnitOfMeasure(saleProduct.product.unitOfMeasure)
        },
        showTotalRowPrice(saleProductOrService) {
            if (saleProductOrService['@type'] === "ProductInWarehouse") {
                let tax = saleProductOrService.product.tax ?? this.getUserCompany.tax

                if (tax === null) {
                    tax = {
                        percent: 0
                    }
                }

                return this.showCurrencyById(
                    this.getCurrencyByShortName(this.saleProductDto.currentCurrency).id,
                    this.saleProductDto.isTaxInPrice ?
                        this.getPriceWithoutTax(saleProductOrService.sum, tax.percent) :
                        saleProductOrService.sum
                )
            }

            return this.showCurrencyById(this.getSale.currency.id, saleProductOrService.price)

        },
        getPriceWithoutTax(price, percent) {
            return price + ((parseFloat(price) * parseFloat(percent)) / 100)
        },
        showPrice(saleProductOrService) {
            if (saleProductOrService['@type'] === "ProductInWarehouse") {
                let tax = saleProductOrService.product.tax ?? this.getUserCompany.tax

                if (tax === null) {
                    tax = {
                        percent: 0
                    }
                }

                let isBonus = false
                let isPercent = false
                let percent = 0

                this.saleProductDto.discounts.find(d => {
                    if (
                        d.discount.discountType === 'product' &&
                        d.discount.discountProducts.find(dp =>
                            dp.isBonus &&
                            dp.product.id === saleProductOrService.product.id &&
                            parseFloat(saleProductOrService.price) === 0.0
                        ) !== undefined
                    ) {
                        return isBonus = true
                    } else if (d.discount.discountType === 'percent') {
                        if (
                            !d.discount.isForAllProducts &&
                            d.discount.discountProducts.find(dp =>
                                !dp.isBonus &&
                                dp.product.id === saleProductOrService.product.id
                            )
                            !== undefined
                        ) {
                            percent = d.discount.discountPercent
                            return isPercent = true
                        }
                    }
                })

                if (isBonus) {
                    return this.$t('sale.discount.discountProduct')
                }

                if (isPercent) {
                    return this.showCurrencyById(
                            this.getCurrencyByShortName(this.saleProductDto.currentCurrency).id,
                            this.calculateReversePercentAmount(
                                this.getPriceWithoutTax(saleProductOrService.price, tax.percent),
                                percent) / saleProductOrService.quantity
                        ) + ' - ' + percent + '% = ' +
                        this.showCurrencyById(
                            this.getCurrencyByShortName(this.saleProductDto.currentCurrency).id,
                            this.getPriceWithoutTax(saleProductOrService.price, tax.percent) / saleProductOrService.quantity
                        )
                }

                return this.showCurrencyById(
                    this.getCurrencyByShortName(this.saleProductDto.currentCurrency).id,
                    saleProductOrService.sum / saleProductOrService.quantity
                )
            }

            return this.showCurrencyById(this.getSale.currency.id, saleProductOrService.price / saleProductOrService.quantity)

        },
        getCustomerName(customer) {
            return customer.isCompany ?
                customer.customerCompany.name : customer.person ?
                    customer.person.givenName + ' ' + customer.person.familyName : ''
        },
        getCustomerPhoneNumber(customer) {
            if (!customer.isCompany) {
                return customer.person.telephone
            }

            return false
        },
        printWindow() {
            window.print()
            setTimeout(() => {
                this.$i18nHelper.toUrl('sales/sale')
            }, 200)
        },

        // localBase

        async fetchCustomerLB(db) {
            this.customer = await db.collection('customer').doc({id: this.saleProductDto.customerId}).get()
        },
        async fetchLastSaleProductDtoLB() {
            let db = new Localbase(this.baseName)

            console.log(this.$route.params.key, 'key')
            db.collection('saleProductDto').doc({key: +this.$route.params.key}).get()
                .then((saleProduct) => {
                    this.saleProductDto = saleProduct
                    this.fetchCustomerLB(db)
                })
        },
    },
    async created() {
        await this.fetchLastSaleProductDtoLB()
    },
    beforeDestroy() {
        this.removePrintStyle();
    },
    watch: {
        'saleProductDto'() {
            if (this.saleProductDto) {
                this.checkTaxInPrice()
                setTimeout(() => {
                            this.printWindow()
                        }, 200)
            }
        }
    }
}
</script>

<style scoped>
@media print {
    .check {
        width: 320px;
        margin: 0;
        padding: 0;
    }

    .go-back-btn {
        display: none;
    }

    td {
        padding: 8px;
    }

    h5 {
        font-size: 16px;
    }

    @page {
        size: 62mm 100mm;
        margin: 20px 0;
        padding: 0;
    }
}

.border {
    border-right: 1px solid black !important;
    border-bottom: 1px solid black !important;
    border-left: 1px solid black !important;
}

.check {
    font-family: 'Roboto', SansSerif, sans-serif;
    color: black !important;
}

.font-size {
    font-size: 13px;
}

.font-weight-bold {
    font-size: 10px;
}

h5 {
    font-weight: bold;
}
</style>
